import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Progress from '@splunk/react-ui/Progress';
import { customThemeVariables } from '../customThemeVariables';

export const PROGRESSBAR_HEIGHT = 5;

const progressbarHideDelay = 400;

interface ProgressBarContainerProps {
    backgroundColor?: string | null;
}

export const ProgressBarContainer = styled.div.attrs(() => ({
    'data-test': 'progress-bar-container',
}))<ProgressBarContainerProps>`
    height: ${PROGRESSBAR_HEIGHT}px;
    background-color: ${(props) =>
        props.backgroundColor || customThemeVariables.vizPanelBackgroundColor};
    width: 100%;
    display: block;
    /* Fix sub-pixel gaps between elements when scaled */
    box-shadow: 0 1px 1px 0
        ${(props) =>
            props.backgroundColor ||
            customThemeVariables.vizPanelBackgroundColor};
`;

const StyledProgress = styled(Progress)`
    height: ${PROGRESSBAR_HEIGHT}px;
`;

interface ProgressBarProps extends ProgressBarContainerProps {
    percentage?: number;
    hasData?: boolean;
}

const VizProgressBar = ({
    backgroundColor,
    percentage = 0,
    hasData = true,
}: ProgressBarProps) => {
    const [showProgress, setShowProgress] = useState(true);

    useEffect(() => {
        if (percentage >= 100) {
            const timer = setTimeout(() => {
                setShowProgress(false);
            }, progressbarHideDelay);
            return () => clearTimeout(timer);
        }
        setShowProgress(true);
        return () => undefined;
    }, [percentage]);

    if (!showProgress || !hasData) {
        return <ProgressBarContainer backgroundColor={backgroundColor} />;
    }
    const progressBarPercent = Math.max(percentage, 5);

    return (
        <ProgressBarContainer backgroundColor={backgroundColor}>
            <StyledProgress
                percentage={progressBarPercent}
                tooltip={`${percentage}% complete`}
            />
        </ProgressBarContainer>
    );
};

export default VizProgressBar;
